module.exports = __webpack_public_path__ + "static/Q3-2021_Financial_Results_Investor_Updated-fbd14ec460257c7cbbeb1480361bcf41.pdf";